import { getCurrentUser } from 'domains/current_user';
import ky from 'ky';
import { ImportedOutgo, ImportedOutgoDetail } from 'types';
import DEFAULT_OPTION from './default_option';

type ImportedOutgoResponse = {
  imported_outgo: ImportedOutgo;
};

export const getImportedOutgo = async (): Promise<ImportedOutgoResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    throwHttpErrors: true,
  };

  const response = await ky.get('imported_outgos', options);

  return response.json();
};

export default getImportedOutgo;

type PostImportedOutgoParams = {
  file_name: string;
  body: string;
};

export const postImportedOutgo = async (
  params: PostImportedOutgoParams,
): Promise<ImportedOutgoResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    json: { imported_outgo: params },
    throwHttpErrors: true,
  };

  const response = await ky.post('imported_outgos', options);

  return response.json();
};

type EmptyResponse = Record<string, never>;

export const applyImportedOutgo = async (): Promise<EmptyResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    throwHttpErrors: true,
  };

  const response = await ky.post('imported_outgos/apply', options);

  return response.json();
};

export const deleteImportedOutgo = async (
  id: number,
): Promise<EmptyResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    throwHttpErrors: true,
  };

  const response = await ky.delete(`imported_outgos/${id}`, options);

  return response.json();
};

type ImportedOutgoDetailResponse = {
  imported_outgo_detail: ImportedOutgoDetail;
};

export const patchImportedOutgoDetail = async (
  detail: ImportedOutgoDetail,
): Promise<ImportedOutgoDetailResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    json: { imported_outgo_detail: detail },
    throwHttpErrors: true,
  };

  const response = await ky.patch(
    `imported_outgo_details/${detail.id}`,
    options,
  );

  return response.json();
};

export const deleteImportedOutgoDetail = async (
  detail: ImportedOutgoDetail,
): Promise<EmptyResponse> => {
  const currentUser = getCurrentUser();

  const options = {
    ...DEFAULT_OPTION,
    headers: {
      'access-token': currentUser?.accessToken,
      client: currentUser?.client,
      uid: currentUser?.uid,
    },
    throwHttpErrors: true,
  };

  const response = await ky.delete(
    `imported_outgo_details/${detail.id}`,
    options,
  );

  return response.json();
};
